var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#3F8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9056 5.81133C13.8513 5.75249 13.7856 5.70558 13.7125 5.67352C13.6394 5.64147 13.5606 5.62495 13.481 5.625H6.51912C6.43934 5.6248 6.36037 5.64122 6.28716 5.67323C6.21395 5.70524 6.14806 5.75216 6.09361 5.81106C6.03916 5.86995 5.99733 5.93955 5.97072 6.01552C5.94411 6.09148 5.9333 6.17217 5.93896 6.25254L6.48083 13.9119C6.50277 14.2076 6.63452 14.484 6.84968 14.6858C7.06484 14.8876 7.34753 14.9998 7.64113 15H12.3624C12.6555 14.9991 12.9375 14.8865 13.152 14.6848C13.3666 14.4831 13.4979 14.2071 13.5198 13.9119L14.0611 6.25254C14.0666 6.17215 14.0557 6.09148 14.0289 6.01556C14.0022 5.93965 13.9602 5.87012 13.9056 5.81133ZM12.8579 6.79688L12.6107 10.3125H7.38935L7.1422 6.79688H12.8579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLogo);
export default __webpack_public_path__ + "static/media/water_logo.4f1ec565fb16f2145857158b1ebc2cf4.svg";
export { ForwardRef as ReactComponent };